<section class="team-area">
    <div class="container py-5">
        <div class="row align-items-center">
            <div class="col-lg-4 col-md-12">
                <div class="project-start-image py-4">
                    <img src="../../../../../assets/img/dev.webp" alt="Pazaryeri Entegrasyonu"
                        title="Pazaryeri Entegrasyonu" width="636" height="425" class="rounded-5" />
                </div>
            </div>

            <div class="col-lg-8 col-md-8">
                <div class="project-start-content px-md-5">
                    <h2 class="mb-4 text-center">Teknik Altyapı ve Süreç Yönetimi</h2>

                    <ul class="ubox">
                        <li>
                            <div>
                                <div class="h5">API Tabanlı Çözümler</div>
                                <p>Shopify ve pazaryerleri arasında güvenli ve güçlü bağlantılar kuran özel API tabanlı
                                    çözümler geliştiriyoruz.</p>
                            </div>
                        </li>
                        <li>
                            <div>
                                <div class="h5">Veri Senkronizasyonu</div>
                                <p>Stok, fiyat ve ürün bilgilerinin gerçek zamanlı senkronizasyonunu sağlayarak satış
                                    kaybını önlüyoruz.</p>
                            </div>
                        </li>
                        <li>
                            <div>
                                <div class="h5">Raporlama ve Analiz</div>
                                <p>Tüm satış kanallarınızı birleştiren kapsamlı raporlama sistemleri ile işletmenizi
                                    daha iyi analiz etmenizi sağlıyoruz.
                                </p>
                            </div>
                        </li>
                        <li>
                            <div>
                                <div class="h5">Sürekli Destek</div>
                                <p>Teknik destek ve yılların getirdiği deneyimle sorunsuz bir e-ticaret deneyimi.</p>
                            </div>
                        </li>
                    </ul>


                </div>




            </div>
        </div>
    </div>
</section>
<section class="faq-area">

    <div class="container py-5">
        <div class="h2 text-center mb-5">Sıkça Sorulan Sorular</div>

        <div class="accordion" id="accordionExample">
            <div class="accordion-item">
                <h2 class="accordion-header" id="headingOne">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        Entegrasyon sonrası ne kadar süre destek alabiliyorum?
                    </button>
                </h2>
                <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        Tüm projelerimizde standart olarak 1 aylık ücretsiz teknik destek sunuyoruz. Bu süre sonrasında
                        aylık bakım ve destek paketlerimizle yanınızda olmaya devam ediyoruz.
                    </div>
                </div>
            </div>
            <div class="accordion-item">
                <h2 class="accordion-header" id="headingTwo">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        Pazaryeri güncellemelerinden etkilenir miyim?
                    </button>
                </h2>
                <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        Pazaryerlerindeki API güncellemeleri ve değişiklikler sürekli takip ediliyor ve
                        entegrasyonlarınız otomatik olarak güncelleniyor.<br>
                        Bakım paketimizle bu hizmet kesintisiz devam ediyor.
                    </div>
                </div>
            </div>
            <div class="accordion-item">
                <h2 class="accordion-header" id="headingThree">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        Hangi ERP ve muhasebe sistemleriyle uyumlu çalışıyorsunuz?
                    </button>
                </h2>
                <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        Logo, Nebim, Mikro, Paraşüt, Zirve ve daha birçok popüler ERP ve muhasebe sistemiyle tam uyumlu
                        entegrasyonlar gerçekleştiriyoruz.
                        Kullandığınız özel bir sistem varsa, uyumluluğu ücretsiz analiz ediyoruz.
                    </div>
                </div>
            </div>
            <div class="accordion-item">
                <h2 class="accordion-header" id="headingFour">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                        Entegrasyon işlemi ne kadar sürer?
                    </button>
                </h2>
                <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        Entegrasyon süreçleri projeye göre değişkenlik gösterebilir, ancak ortalama süre 1-3 hafta
                        arasında değişir. Detaylı bir takvim için bizimle iletişime geçebilirsiniz.
                    </div>
                </div>
            </div>
            <div class="accordion-item">
                <h2 class="accordion-header" id="headingFive">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                        Ürünlerim entegrasyona hazır mı?
                    </button>
                </h2>
                <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        Entegrasyona başlamadan önce ürünlerinizi uygun formatta düzenleyebilmeniz için gerekli
                        talimatları sağlıyoruz. Bizimle çalıştığınızda, ürünlerinizi entegrasyona hazırlamak için her
                        adımda size yardımcı olacağız.
                    </div>
                </div>
            </div>
            <div class="accordion-item">
                <h2 class="accordion-header" id="headingSix">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                        Ödeme işlemleri nasıl yapılacak?
                    </button>
                </h2>
                <div id="collapseSix" class="accordion-collapse collapse" aria-labelledby="headingSix"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        Ödeme işlemleri güvenli ödeme altyapılarımız ile yapılmaktadır. Kredi kartı, banka transferi
                        gibi birden fazla ödeme seçeneği sunuyoruz.
                    </div>
                </div>
            </div>
            <div class="accordion-item">
                <h2 class="accordion-header" id="headingSeven">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                        Veri güvenliğini nasıl sağlıyorsunuz?
                    </button>
                </h2>
                <div id="collapseSeven" class="accordion-collapse collapse" aria-labelledby="headingSeven"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        Tüm verileriniz yüksek güvenlik protokolleri ile korunmaktadır. GDPR ve diğer yerel veri koruma
                        yasalarına tamamen uyumluyuz.
                    </div>
                </div>
            </div>
            <div class="accordion-item">
                <h2 class="accordion-header" id="headingEight">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
                        Mobil uyumlu mu çalışıyorsunuz?
                    </button>
                </h2>
                <div id="collapseEight" class="accordion-collapse collapse" aria-labelledby="headingEight"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        Evet, entegrasyonlarımız ve platformlarımız mobil uyumlu olacak şekilde tasarlanmıştır. Mobil
                        cihazlar üzerinden de sorunsuz erişim sağlayabilirsiniz.
                    </div>
                </div>
            </div>
            <div class="accordion-item">
                <h2 class="accordion-header" id="headingNine">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
                        Fatura işlemleri nasıl yapılır?
                    </button>
                </h2>
                <div id="collapseNine" class="accordion-collapse collapse" aria-labelledby="headingNine"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        Fatura işlemleri entegrasyon sürecinin sonunda otomatik olarak düzenlenmektedir. Ayrıca her
                        fatura detaylarıyla birlikte size e-posta olarak iletilir.
                    </div>
                </div>
            </div>
            <div class="accordion-item">
                <h2 class="accordion-header" id="headingTen">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseTen" aria-expanded="false" aria-controls="collapseTen">
                        Hangi pazaryerlerine entegrasyon yapabiliyorsunuz?
                    </button>
                </h2>
                <div id="collapseTen" class="accordion-collapse collapse" aria-labelledby="headingTen"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        Trendyol, Hepsiburada, N11, Amazon, eBay, Etsy ve daha birçok popüler pazaryeriyle entegrasyon
                        sağlamaktayız.
                    </div>
                </div>
            </div>
        </div>


    </div>

</section>

<section class="que-area">

    <div class="container py-5">

        <div class="row align-items-center">
            <div class="col-lg-4 col-md-8">
                <div class="project-start-image py-4">
                    <img src="../../../../../assets/img/que.webp" alt="Pazaryeri Entegrasyonu"
                        title="Pazaryeri Entegrasyonu" width="636" height="425" class="rounded-5" />
                </div>
            </div>

            <div class="col-lg-8 col-md-8">
                <div class="project-start-content px-md-5">
                    <h2 class="mb-4 text-center">E-Ticaret Hedeflerinize Birlikte Ulaşalım</h2>

                    <ul class="ubox">
                        <li>
                            <div>
                                <div class="h5">Ücretsiz Ön Analiz</div>
                                <p>İhtiyaçlarınızı anlamak için detaylı bir analiz yapıyor ve mevcut durumunuza özel
                                    çözümler sunuyoruz. Bu aşamada hiçbir ücret talep etmiyoruz.</p>
                            </div>
                        </li>
                        <li>
                            <div>
                                <div class="h5">Kişiselleştirilmiş Teklif</div>
                                <p>İhtiyaçlarınıza ve bütçenize uygun olarak hazırladığımız özel teklifi size sunuyor ve
                                    tüm sorularınızı cevaplıyoruz.</p>
                            </div>
                        </li>
                        <li>
                            <div>
                                <div class="h5">Hızlı Kurulum</div>
                                <p>Anlaşma sonrası profesyonel ekibimiz hemen işe koyuluyor ve ortalama 7 iş günü içinde
                                    entegrasyonlarınızı tamamlıyoruz.</p>
                            </div>
                        </li>

                    </ul>

                    <p class="mt-4">İster yeni bir mağaza kuruyor olun, ister mevcut mağazanızı büyütmek isteyin; uzman
                        ekibimiz size özel çözümler sunmak için hazır. Hemen bir toplantı planlayın veya detaylı bilgi
                        almak için bizimle iletişime geçin.</p>

                    <div class="py-4 d-flex justify-content-center">
                        <a [routerLink]="'/iletisim'" class="btn btn-dark-blue me-3">
                            <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24">
                                <rect width="24" height="24" fill="none" />
                                <path fill="currentColor"
                                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
                            </svg>
                            Bilgi Alın</a>
                        <a href="https://calendly.com/dotcrea/" target="_blank" class="btn btn-primary">
                            <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 48 48">
                                <rect width="48" height="48" fill="none" />
                                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                    d="M41.05 12.6c1.63-1.3 2.85-.23 2.85 1.14v20.52c0 1.73-1.22 2.44-2.85 1.14L26.79 24ZM14 8v32M4.9 17.16h21.89v13.68H4.9m0-13.68L14 8h18.5a3.2 3.2 0 0 1 2.85 2.85v26.26A3.2 3.2 0 0 1 32.5 40H7.75a2.81 2.81 0 0 1-2.85-2.89Z"
                                    stroke-width="1" />
                            </svg>
                            Meet Planlayın</a>
                    </div>
                </div>




            </div>
        </div>

    </div>
</section>